import { render, staticRenderFns } from "./SendSomeSms.vue?vue&type=template&id=7c2d480a"
import script from "./SendSomeSms.vue?vue&type=script&lang=js"
export * from "./SendSomeSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports